module.exports = __webpack_public_path__ + "static/media/ot_8.06711939.JPG";